import { Application } from "@/types/application";
import SimpleApplicationsTable from "@/components/tables/SimpleApplicationsTable";
import PaginationControls from "@/components/PaginationControls";
import { useIsMobile } from "@/hooks/use-mobile";
import OptimizedMobileTable from "@/components/tables/mobile/OptimizedMobileTable";

interface MainContentProps {
  applications: Application[];
  onRowClick: (application: Application) => void;
  onApplicationDeleted?: () => void;
  selectedApplicationId?: string;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalCount: number;
  pageSize: number;
  selectedEmiMonth?: string | null;
}

const MainContent = ({
  applications,
  onRowClick,
  selectedApplicationId,
  currentPage,
  totalPages,
  onPageChange,
  totalCount,
  pageSize,
  selectedEmiMonth
}: MainContentProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4">
      {applications.length > 0 && (
        <div className="text-sm text-gray-700">
          Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} applications.
        </div>
      )}

      {/* Table */}
      {isMobile ? (
        <OptimizedMobileTable
          applications={applications}
          onRowClick={onRowClick}
          selectedApplicationId={selectedApplicationId}
          selectedEmiMonth={selectedEmiMonth}
        />
      ) : (
        <SimpleApplicationsTable
          applications={applications}
          onRowClick={onRowClick}
          selectedApplicationId={selectedApplicationId}
          selectedEmiMonth={selectedEmiMonth}
        />
      )}

      {applications.length > 0 && totalPages > 1 && (
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          totalCount={totalCount}
          pageSize={pageSize}
        />
      )}
    </div>
  );
};

export default MainContent;

